import React from 'react';
import { modules } from '../data/modules';
import { PRODUCT } from '../data/constants';
export function SystemSection() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-161" data-mp="3gihoxkzfi0s2">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-162" data-mp="3bimx9f7tx75y">
        <h2 className="text-center text-2xl leading-none text-navy sm:text-4xl" data-id="element-163" data-mp="3bhbu9hm7k3fw">
          EVERYTHING YOU NEED.{' '}
          <span className="text-aviation" data-id="element-164" data-mp="36lwhkszxsdl2">ONE COMPLETE PRIVATE PILOT VISUAL SYSTEM.</span>
        </h2>
        <p className="mt-1.5 text-center font-display text-sm font-semibold uppercase tracking-wide text-gold-dark sm:text-lg" data-id="element-165" data-mp="31mtkpvu41do6">
          6 Professional Aviation Visual Modules In One Organized System
        </p>

        <div className="mx-auto mt-3 max-w-4xl rounded-xl border-2 border-navy bg-white p-3 text-center shadow-sm sm:p-5" data-id="element-166" data-mp="2ntascrjjbl9g">
          <p className="font-display text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-167" data-mp="2iur60q1147gk">
            ✈️ {PRODUCT}
          </p>
          <p className="mt-1.5 text-sm leading-snug text-graphite sm:text-base" data-id="element-168" data-mp="2dvwk3f7rm2s8">
            {PRODUCT} brings aircraft systems, cockpit instruments, aerodynamics, VFR
            navigation, aviation weather, flight planning, and essential flight procedures
            together in one complete visual educational reference system.
          </p>
          <p className="mx-auto mt-2 w-fit max-w-full rounded-lg bg-navy px-3 py-1 font-display text-[11px] font-bold uppercase tracking-wide text-white sm:text-base" data-id="element-169" data-mp="yzln17s13kkt">
            STUDY → <span className="text-gold" data-id="element-170" data-mp="1rosi1ws9xs1b">VISUALIZE</span> → UNDERSTAND →{' '}
            <span className="text-gold" data-id="element-171" data-mp="1ro0vtckkh6np">INTERPRET</span> → PRACTICE →{' '}
            <span className="text-gold" data-id="element-172" data-mp="1cqqevnp5n8kl">REVIEW</span>
          </p>
        </div>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-173" data-mp="1hptir4tef8qz">
          {modules.map(module => <article key={module.title} className="rounded-xl border border-navy/10 bg-white p-3 shadow-sm sm:p-4" style={{
          borderLeft: `6px solid ${module.color}`
        }} data-id="element-174" data-mp="1bbfyeddy6mu">
              <h3 className="flex items-start gap-1.5 text-sm leading-tight text-navy sm:text-base" data-id="element-175" data-mp="28xl8qr8uhcj4">
                <span className="text-aviation" aria-hidden="true" data-id="element-176" data-mp="23ztkq8bbmak7">
                  ✓
                </span>
                {module.title}
              </h3>
              <p className="mt-1 text-sm leading-snug text-graphite" data-id="element-177" data-mp="1ua0apbqtu3i2">{module.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}